<template>
  <div class="page_all_login">
    <div class="page_header_login">
      <div class="title_login">防災サポート</div>
    </div>
    <div class="page_main">
      <table class="tbl_login">
        <tbody class="tbody_login">
          <tr>
            <td class="td_content_top">
              <div>
                <input v-model.trim="$v.userName.$model" type="text" class="text_login_id" placeholder="ID"/>
              </div>
              <div class="message">
                <div v-if="$v.userName.$dirty">
                  <div class="error" v-if="!$v.userName.required">IDを入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td_content_middle">
              <div>
                <input v-model.trim="$v.password.$model" type="password" class="text_password" placeholder="パスワード"/>
              </div>
              <div class="message">
                <div v-if="$v.password.$dirty">
                  <div class="error" v-if="!$v.password.required">パスワードを入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td_content_bottom">
              <div>
                <button :disabled="$v.$invalid" class="btn_login" v-on:click="login()">ログイン</button>
                <div class="message">
                  <div class="error">{{ message }}</div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  data: function() {
    return {
      userName: "",
      password: "",
      message: ""
    }
  },
  mounted: function() {
    // トークン情報
    this.$store.commit('setStateIdToken', "")
    this.$store.commit('setStateAccessToken', "")
    this.$store.commit('setStateRefreshToken', "")
    // ログイン情報
    this.$store.commit('setStateIsAuthenticated', false)
    this.$store.commit('setStateIsLogin', false)
    this.$store.commit('setStateIsAdmin', false)
    // 担当者情報
    this.$store.commit('setStateChargeId', "")
    this.$store.commit('setStateMunicipalityKey', "")
    this.$store.commit('setStateIsPushAuth', false)
    this.$store.commit('setStateIsSoundAuth', false)
    // sessionstrage
    sessionStorage.clear()
  },
  methods: {
    login: async function() {
      try {
        const response = await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'login/charge', {
          user_name: this.userName,
          password: this.password
        });

        // ログイン情報
        this.$store.commit('setStateChargeId', response.data.Username)
        // トークン情報
        this.$store.commit('setStateIdToken', response.data.IdToken)
        this.$store.commit('setStateAccessToken', response.data.AccessToken)
        this.$store.commit('setStateRefreshToken', response.data.RefreshToken)

        // 担当者情報取得
        const info = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'charge/info', {
          params: {
            charge_email: response.data.Username
          }
        })

        console.log(info)
        var start_date = info.data[0].start_date
        var end_date = info.data[0].end_date
        var today = this.$moment(new Date).format('YYYY-MM-DD')

        // 民間対応
        this.$store.commit('setStateCompanyId', info.data[0].company_id)
        this.$store.commit('setStateCompanyFlg', info.data[0].company_flg)
        this.$store.commit('setStateCompanyCognitoUserStatus', info.data[0].company_cognito_user_status)
        console.log(info.data[0].company_cognito_user_status)
        console.log("companyId")
        console.log(this.$store.getters.getStateCompanyCognitoUserStatus)

        // 担当者の利用開始日、利用終了日のチェック
        var validError = false
        if (end_date == "") {
          if (this.$moment(today).isBefore(start_date, 'day')) {
            validError = true
          }
        } else {
          if (this.$moment(today).isBefore(start_date, 'day') || this.$moment(today).isAfter(end_date, 'day')) {
            validError = true
          }
        }
        if (validError) {
          this.message = "ログインの有効期限外です。"
          this.password = ""
          this.$v.password.$reset()
          return
        }

        // 自治体ID
        this.$store.commit('setStateMunicipalityKey', info.data[0].municipality_key)
        // プッシュ通知フラグ
        info.data[0].push_auth == 1 ? this.$store.commit('setStateIsPushAuth', true) : this.$store.commit('setStateIsPushAuth', false)
        // 防災音通知フラグ
        info.data[0].sound_auth == 1 ? this.$store.commit('setStateIsSoundAuth', true) : this.$store.commit('setStateIsSoundAuth', false)

        if (response.data.UserStatus === 'FORCE_CHANGE_PASSWORD') {
          // ログイン情報
          this.$store.commit('setStateChargeId', response.data.Username)
          // 仮パスワードのユーザーはパスワード設定画面
          this.$store.commit('setStateIsLogin', true)
          this.$router.push({ name: 'passwordSetting' });
          return;
        }

        // ログイン済みフラグ = true
        this.$store.commit('setStateIsLogin', true)


        // それ以外のユーザーは認証済みとし、地域画面
        this.$store.commit('setStateIsAuthenticated', true)
        this.$router.push({ name: 'areaList' })

      } catch (err) {
        this.password = ""
        // validationsモデルオブジェクトをリセット
        this.$v.password.$reset()
        this.message = err.response.data.errorMessage
      }
    }
  },
  validations: {
    userName: {
      required
    },
    password: {
      required
    }
  }
}
</script>

<style scoped>
table tr {
  border: none;
}
table td.td_content_top {
  text-align: left;
  border: none;
  padding: 20px 50px 0px 50px;
}
table td.td_content_middle {
  text-align: left;
  border: none;
  padding: 0px 50px 0px 50px;
}
table td.td_content_bottom {
  text-align: left;
  border: none;
  padding: 0px 50px 0px 50px;
}
</style>